<!-- Inline mode: renders directly into the host page (no overlay) -->
<div *ngIf="isOpen && inline" class="bg-white" style="font-family:sans-serif;">
  <ng-container *ngTemplateOutlet="formTpl; context: { inline: true }"></ng-container>
</div>

<!-- Modal mode: overlay + centered card (legacy default) -->
<ng-container *ngIf="isOpen && !inline">
  <!-- Overlay -->
  <div #addrOverlay (click)="close()"
    style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:9998;"></div>

  <!-- Wrapper: viewport center -->
  <div #addrWrapper
    style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:9999;display:flex;align-items:center;justify-content:center;padding:0.75rem;pointer-events:none;">

    <!-- Modal -->
    <div class="address-modal bg-white rounded-lg shadow-2xl flex flex-col pointer-events-auto"
      style="width:90vw;max-width:650px;max-height:80vh;overflow:hidden;font-family:sans-serif;">

      <!-- Close -->
      <div class="flex justify-end p-3 pb-0 shrink-0">
        <button (click)="close()"
          class="w-8 h-8 rounded-full bg-[#E86A10] text-white flex items-center justify-center hover:bg-[#d45e0e] shadow-lg">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
      </div>

      <ng-container *ngTemplateOutlet="formTpl; context: { inline: false }"></ng-container>
    </div>
  </div>
</ng-container>

<!-- Shared form template -->
<ng-template #formTpl let-inline="inline">
  <!-- Content -->
  <div [class]="inline ? 'pt-1' : 'modal-body overflow-y-auto flex-1 px-5 sm:px-8 pb-4'">
    <h2 class="text-base sm:text-lg font-bold text-gray-800 mb-4 sm:mb-5" style="font-family: 'Roboto Slab', serif;">
      {{ isEditMode ? 'Edit Address' : 'Add New Address' }}
    </h2>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
      <!-- Full Name -->
      <div>
        <input [(ngModel)]="form.fullname" type="text" placeholder="Full Name *"
          class="w-full border border-gray-300 rounded px-3 sm:px-4 py-2.5 sm:py-3 text-sm outline-none focus:border-[#600b0b] transition-colors" />
      </div>
      <!-- Mobile -->
      <div>
        <input [(ngModel)]="form.mobile" type="tel" maxlength="10" placeholder="Mobile *"
          class="w-full border border-gray-300 rounded px-3 sm:px-4 py-2.5 sm:py-3 text-sm outline-none focus:border-[#600b0b] transition-colors" />
      </div>
      <!-- Address -->
      <div class="sm:col-span-2">
        <textarea [(ngModel)]="form.address" rows="2" placeholder="Address *"
          class="w-full border border-gray-300 rounded px-3 sm:px-4 py-2.5 sm:py-3 text-sm outline-none focus:border-[#600b0b] resize-none transition-colors"></textarea>
      </div>
      <!-- City with autocomplete -->
      <div class="relative">
        <input [value]="citySearchText"
          (input)="onCityInput($any($event.target).value)"
          (focus)="showCityDropdown = cities.length > 0"
          (blur)="hideCityDropdown()"
          type="text" placeholder="City *" autocomplete="off"
          class="w-full border rounded px-3 sm:px-4 py-2.5 sm:py-3 text-sm outline-none transition-colors"
          [class]="isCityValid ? 'border-green-400 focus:border-green-500' : 'border-gray-300 focus:border-[#600b0b]'" />
        <!-- Loading spinner -->
        <div *ngIf="cityLoading" class="absolute right-3 top-1/2 -translate-y-1/2">
          <span class="w-4 h-4 border-2 border-[#600b0b] border-t-transparent rounded-full animate-spin inline-block"></span>
        </div>
        <!-- Selected check -->
        <div *ngIf="isCityValid && !cityLoading" class="absolute right-3 top-1/2 -translate-y-1/2 text-green-500">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>
        </div>
        <!-- Dropdown -->
        <div *ngIf="showCityDropdown && cities.length > 0"
          class="absolute left-0 right-0 top-full mt-1 bg-white border border-gray-200 rounded-lg shadow-xl z-50 max-h-[200px] overflow-y-auto">
          <button *ngFor="let city of cities" (mousedown)="selectCity(city)"
            class="w-full text-left px-4 py-2.5 text-sm hover:bg-gray-50 hover:text-[#600b0b] transition-colors border-b border-gray-50 last:border-0">
            <span class="font-medium">{{ city.name }}</span>
            <span *ngIf="city.state" class="text-gray-400 text-xs ml-1">({{ city.state.name }}<span *ngIf="city.state.country">, {{ city.state.country.name }}</span>)</span>
          </button>
        </div>
        <!-- Error -->
        <p *ngIf="citySearchText && !isCityValid && !cityLoading && cities.length === 0 && citySearchText.length >= 2"
          class="text-[10px] text-red-400 mt-1">Please select a valid city from the dropdown</p>
      </div>
      <!-- Zipcode -->
      <div>
        <input [(ngModel)]="form.zipcode" type="text" maxlength="6" placeholder="Zipcode *"
          class="w-full border border-gray-300 rounded px-3 sm:px-4 py-2.5 sm:py-3 text-sm outline-none focus:border-[#600b0b] transition-colors" />
      </div>
      <!-- Company Name -->
      <div>
        <input [(ngModel)]="form.company_name" type="text" placeholder="Company Name"
          class="w-full border border-gray-300 rounded px-3 sm:px-4 py-2.5 sm:py-3 text-sm outline-none focus:border-[#600b0b] transition-colors" />
      </div>
      <!-- GST -->
      <div>
        <input [(ngModel)]="form.gst" type="text" maxlength="16" placeholder="GST No"
          class="w-full border border-gray-300 rounded px-3 sm:px-4 py-2.5 sm:py-3 text-sm outline-none focus:border-[#600b0b] transition-colors" />
      </div>
      <!-- PAN -->
      <div>
        <input [(ngModel)]="form.pan" type="text" maxlength="10" placeholder="PAN (e.g. ABCDE1234F)"
          class="w-full border border-gray-300 rounded px-3 sm:px-4 py-2.5 sm:py-3 text-sm outline-none focus:border-[#600b0b] transition-colors" />
      </div>
    </div>

    <p *ngIf="error" class="text-xs text-red-500 mt-3">{{ error }}</p>
  </div>

  <!-- Footer -->
  <div [class]="inline ? 'mt-4 pt-4 border-t border-gray-200 flex gap-3' : 'border-t border-gray-200 p-3 sm:p-4 flex gap-3 shrink-0'">
    <button (click)="save()" [disabled]="loading"
      class="flex-1 bg-[#600b0b] text-white py-2.5 sm:py-3 rounded text-xs sm:text-sm font-bold uppercase tracking-wider hover:bg-[#8c1c1c] transition-colors disabled:opacity-50 inline-flex items-center justify-center gap-2">
      <span *ngIf="loading" class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin inline-block"></span>
      {{ loading ? 'Saving...' : 'Save' }}
    </button>
    <button (click)="close()"
      class="flex-1 bg-gray-300 text-gray-600 py-2.5 sm:py-3 rounded text-xs sm:text-sm font-bold uppercase tracking-wider hover:bg-gray-400 hover:text-white transition-colors">
      {{ inline ? 'Cancel' : 'Close' }}
    </button>
  </div>
</ng-template>
